
import {apolloClient} from '../../utils/apolloClient'
import { ExecutionResult } from 'graphql'
import React, { useState } from 'react'
import { SEND_CHANGE_SURGERY_EMAIL } from 'src/mutations/SEND_CHANGE_SURGERY_EMAIL'
import { SEND_CANCEL_SURGERY_EMAIL } from 'src/mutations/SEND_CANCEL_SURGERY_EMAIL'
import Chats from '../Chats/Chats'
import { steps } from './analyzeNextSteps'
import {
  SendCancelDateMutation,
  SendChangeDateMutation,
  SendChangeDateMutationVariables,
} from '../../schema/schemaTypes'
import './Chatbot.css'
import { withRouter } from 'react-router-dom'

export interface IResponseBotObject {
  purpose: string
  message: string
  options?: string[]
  sender: string
  delay?: number
}

function Chatbot({history}:{history:any}) {
  console.log(history)
  console.log('chatbot')

  const chatStep = sessionStorage.getItem('chatStep')
  const initStep = chatStep ? parseInt(chatStep, 10) : 0
  
  const [flow, setFlow] = useState<string>(window.sessionStorage.getItem('chatFlow') || 'intro')
  const [catchAllLevel, setCatchAllLevel] = useState<number>(0)
  const [userResponse, setUserResponse] = useState<string>('')
  const [isShowing, setIsShowing] = useState<boolean>(false)
  const [step, setStep] = useState<number>(initStep)
  const [botResponse, setBotResponse] = useState<IResponseBotObject>({
    purpose: '',
    message: '',
    sender: 'bot',
    delay: 0,
  })
  const [sendUserResponse, setSendUserResponse] = useState<string>('')

  function catchAllFlow() {
    
    if(catchAllLevel === 0){
      setBotResponse({ purpose: '', message: 'Lo siento, no estoy seguro de que entiendo.', sender: 'bot' })
      setCatchAllLevel(1)
    }

    if(catchAllLevel === 1){
      setBotResponse({ purpose: '', message: 'Cielos... No capté eso..' , sender: 'bot' })
      setTimeout(() => {
      setSendUserResponse('')
      setUserResponse('')
      setBotResponse({ purpose: '', message: 'No he tomado suficiente café hoy, lo siento por eso.', sender: 'bot' })}, 1000)
      setTimeout(() => {setBotResponse({ purpose: '', message: '¿Qué quieres hacer?', options: ['Flujo principal.', 'Flujo secundario.'], sender: 'bot' })}, 2000)

      setCatchAllLevel(2)
    }

    if(catchAllLevel === 2){
      setBotResponse({ purpose: '', message: 'Intentemos esto una vez más...' , options: ['Ir a la página de inicio.', 'Reanudar.'], sender: 'bot' })
      setCatchAllLevel(0)
    }
  }

  const sendCancelEmail = async () => {
    // TODO
    try {
      const {data}: ExecutionResult<SendCancelDateMutation> =
        await apolloClient.mutate<SendCancelDateMutation, null>({
          mutation: SEND_CANCEL_SURGERY_EMAIL,
        }) as any
      if (!data || !data.sendCancelDateMutation) {
        // send error
      }
      // send confirm
     } catch (err) {
        // send error message to user
      }
    }
  

  const sendChangeEmail = async (date: string) => {
    // TODO
    try {
      const {data}: ExecutionResult<SendChangeDateMutation> =
        await apolloClient.mutate<SendChangeDateMutation, SendChangeDateMutationVariables>({
          mutation: SEND_CHANGE_SURGERY_EMAIL, variables: {date},
        }) as any
      if (!data || !data.sendChangeDateMutation) {
        // send error
      }
      // send confirm
     } catch (err) {
        // send error message to user
      }
    }

  // setting next step when there's response and option click
  const setNextStep = (response: string) => {

    if(response.toLowerCase() === 'goodbye'){
      setSendUserResponse(response)
      
        setBotResponse({purpose: 'sender',message: 'Muy bien, eso es todo lo que tengo por hoy.', sender: 'bot'})
        setTimeout(() => {
          setSendUserResponse('')
          setUserResponse('')
          setBotResponse({purpose: 'sender',message: '¡Vuelve a este chatbox si tiene alguna otra pregunta!', sender: 'bot'})
        }, 1000)

        setTimeout(() => {
          setSendUserResponse('')
          setUserResponse('')
          setBotResponse({purpose: 'sender',message: 'Esto no es un adiós, nos vemos más tarde ✌️ ¡Que tengas un gran día!', sender: 'bot'})
        }, 2000)
      
        setTimeout(() => {
          setIsShowing(false)
        }, 5000)
        return
    }

    if(response === 'Flujo principal.'){
      changeFlow('main', response)

      return
    }

    if(response === 'Flujo secundario.'){
      changeFlow('secondary', response)

      return
    }

    if(response === 'Ir a la página de inicio.'){
      history.push('/')

      return
    }

    if(response === 'Reanudar.'){
      changeFlow('main', response)
      return
    }
    const res = steps[flow](step, response, history)
    if(res.catchAll){
      setSendUserResponse(response)
      catchAllFlow()
      return
    }else{
    setCatchAllLevel(0)
    setStep(prevState => prevState + 1)

    
    
    if(res.newFlow){
      changeFlow(res.newFlow, response)
    }else{
      setSendUserResponse(response)
      if(res?.length > 1){

        res.forEach((x: any, i: number) => {
          if(x.sendUpdateDateRequest){
            sendChangeEmail(x.newDate)
          }
      
          if(x.sendCancelDateRequest){
            sendCancelEmail()
          }

          setTimeout(() => {
            setSendUserResponse('')
            setUserResponse('')
            setBotResponse({...x, sender: 'bot'})
            setTimeout(() => {
              if(x.trackVideo){
              const title = x.title
              const myPlayer: HTMLVideoElement = document.getElementById(x.videoId) as HTMLVideoElement
              
              if(myPlayer){
              myPlayer.addEventListener('play', () => {
             
                (window as any).trackVideo(
                  window.location.pathname,
                  title,
                  myPlayer.duration,
                  myPlayer.currentTime,
                  'play',
                )
              })
              myPlayer.addEventListener('pause', () => {
                (window as any).trackVideo(
                  window.location.pathname,
                  title,
                  myPlayer.duration,
                  myPlayer.currentTime,
                  'pause',
                )
              })
              myPlayer.addEventListener('ended', async () => {
                (window as any).trackVideo(
                  window.location.pathname,
                  title,
                  myPlayer.duration,
                  myPlayer.currentTime,
                  'ended',
                )
                // this.videoFinished()
              })
            }
          }
            }, 1000)
          }, 1000 * i + (x.delay ? x.delay : 0))
          
        })

        
      
      }else{
        setBotResponse({ ...res, sender: 'bot' })
      }
      setUserResponse('')
      const chatWindow = document.getElementById('chat-content')
      const xH = chatWindow?.scrollHeight || 0
      chatWindow?.scrollTo(0, xH)
     
    }
    }
  }

  const changeFlow = (flowName: string, response: string) => {
    setCatchAllLevel(0)
    setStep(0)
    setFlow(flowName)
    window.sessionStorage.setItem('chatFlow', flowName)
    window.sessionStorage.setItem('chatStep', '0')
   
    const res = steps[flowName](0, response, history)
    setSendUserResponse(response)
    if(res?.length > 1){
      setBotResponse({...res[0], sender: 'bot'})
      setTimeout(() => {
        setSendUserResponse('')
        setUserResponse('')
        setBotResponse({...res[1], sender: 'bot'})
      }, 1000)

      if(res.length > 2){
      setTimeout(() => {
        setSendUserResponse('')
        setUserResponse('')
        setBotResponse({...res[2], sender: 'bot'})
      }, 2000)
    }
    }else{
      setBotResponse({ ...res, sender: 'bot' })
    }
      setUserResponse('')
      const chatWindow = document.getElementById('chat-content')
      const xH = chatWindow?.scrollHeight || 0
      chatWindow?.scrollTo(0, xH)
      window.sessionStorage.setItem('chatStep', (step + 1).toString())
   
      setStep(prevState => prevState + 1)
     
  }

  const optionClick = (e: React.MouseEvent<HTMLElement>) => {
    const option = e.currentTarget.dataset.id
    if (option) {
      setNextStep(option)
    }
  }

  // event handlers
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserResponse(e.target.value)
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setNextStep(userResponse)
  }
  
  return (
    <>
    <button className="chat-button" onClick={() => setIsShowing(true)} style={{position:'fixed', right: '30px', bottom: '30px'}}><img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/billy.png" style={{width: '60px', height: '60px'}}/>
            </button>
    
      <div className="chat-container" style={{display: isShowing ? 'block' : 'none'}}>
        <div className="chat-header">
          <div style={{display:'flex', alignItems: 'center'}}>
            <img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/billy.png" style={{width: '40px', height: '40px'}}/>
            <span style={{marginLeft: '10px', fontSize: '25px', justifySelf: 'flex-start'}}>Billy Bot</span>
          </div>
          <img className="close-btn" role="button" src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/close.png" onClick={() => setIsShowing(false)}/>
        </div>
      <div className="chat-content">
      <Chats
        history={history}
        userResponse={userResponse}
        botResponse={botResponse}
        sendUserResponse={sendUserResponse}
        optionClick={optionClick}
      />
      </div>
      <form onSubmit={e => handleSubmit(e)} className="form-container">
        <input
          onChange={e => handleInputChange(e)}
          placeholder="Enter Message..."
          value={userResponse}
        />
        <button className="sendButton">
          <img src="https://uci-images.s3.us-west-1.amazonaws.com/images/chatbot/send.png"/>
        </button>
      </form>
    </div>
    
    </>
    
  )
}

export default withRouter(Chatbot)





// WEBPACK FOOTER //
// ./src/organisms/Chatbot/Chatbot.tsx